import React, { FC } from 'react';
import { usePostComposer } from 'app/modules/posts/modules/post/components/composer/PostComposerProvider';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { SUBTYPE as POST_SUBTYPE } from '@kontentino/kontentino-constants/Posts';
import PostComposerTrialReelInstagram from 'app/modules/posts/modules/post/components/composer/postComposerTrialReel/PostComposerTrialReelInstagram';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import { Icon } from '@kontentino/ui';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faClapperboardPlay } from '@fortawesome/pro-regular-svg-icons/faClapperboardPlay';
import { useTranslation } from 'react-i18next';

type Props = {};

const PostComposerTrialReel: FC<Props> = () => {
  const { form, setForm } = usePostComposer();
  const { t } = useTranslation();

  if (form.page.type === TYPE.INSTAGRAM && form.subtype === POST_SUBTYPE.REEL) {
    return (
      <AccordionWidget
        title={t('widgets.title.trialReel', 'Trial Reel')}
        titleSuffix={(isOpen) =>
          !isOpen &&
          form.attachments.is_trial_reel && (
            <div className="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-grayscale-10 tw-text-grayscale-100">
              <Icon icon={faCheck} size="sm" />
            </div>
          )
        }
        icon={
          <div className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-bg-grayscale-10 tw-text-grayscale-100">
            <Icon icon={faClapperboardPlay} />
          </div>
        }
        initialIsOpen={true}
        data-name="posts-composer_trial-reel"
      >
        <PostComposerTrialReelInstagram
          value={{
            is_trial_reel: form.attachments.is_trial_reel,
            share_to_everyone_automatically:
              form.attachments.share_to_everyone_automatically,
          }}
          onChange={(updater) =>
            setForm((prev) => ({
              attachments: {
                ...prev.attachments,
                ...updater(prev.attachments),
              },
            }))
          }
        />
      </AccordionWidget>
    );
  }

  return null;
};

export default PostComposerTrialReel;
